import { columns, sortOrder } from './ClassDetailTable.constants';

export const CHANGE_SORT = 'manage/classDetailTable/CHANGE_SORT';
export const changeSort = (sortDirection, sortField) => ({ type: CHANGE_SORT, sortDirection, sortField });

export const initialState = {
  sortField: columns.CLASS_NAME,
  sortDirection: sortOrder.ASC,
};

export default (state = initialState, action) => {
  const { type, sortDirection, sortField } = action;

  switch (type) {
    case CHANGE_SORT:
      return { ...state, sortDirection, sortField };
    default:
      return state;
  }
};
